module.exports = __webpack_public_path__ + "static/media/blog-40-1.47f107af.webp";